import React, { FC, memo, useRef, useMemo, useCallback, useState, useEffect } from 'react'
import dayjs from 'dayjs'
import { useSetState } from 'ahooks'
import Calendar from '../calendar'
import CalendarItem from './item'
import style from './index.module.less'
import Icon from 'dffl-icons'

interface IProps {
  callback?: (obj: any) => void
  // paramsExr: any
  hideHead?: boolean // 是否显示头部
  calendarDetailList: any[]
  icon?: string
}

interface calendarObj {
  // date: string
  // netPrice: number
  // salePrice: number
  // currency: string
  // stock: number
  // marketPrice: number
  // marketPriceCurrency: 
  date: string,
  salePrice: number,
  weekDay: string,

}

const CalendarHeader = (props: IProps) => {
  const {callback, calendarDetailList, hideHead = false, icon} = props;
  const containerDom = useRef<HTMLDivElement>(null)
  const [currentDate, setCurrentDate] = useState<string>('')
  const ulDom = useRef<HTMLUListElement>(null)
  const [state, setState] = useSetState<{
    visible: boolean
  }>({
    visible: false,
  })

  const handleOpen = useCallback(() => {
    setState({
      visible: true,
    })
  }, [])

  const handleClose = useCallback(() => {
    setState({
      visible: false,
    })
  }, [])

  const handleChange = useCallback((value: any) => {
    const val = value ? dayjs(value).format('YYYY-MM-DD') : ''
    setCurrentDate(val)
    setState({
      visible: false,
    })
    const obj = calendarDetailList.find((m: calendarObj) => m?.date === val)
    callback && callback(obj)
  }, [calendarDetailList])
  
  const getDates = useMemo(() => {
    // 今天的日期
    const now = dayjs(new Date()).format('YYYY-MM-DD')
    // 明天
    const tomorrow = dayjs(new Date(new Date().getTime() + 24 * 60 * 60 * 1000)).format('YYYY-MM-DD');
    let curDate = currentDate || now
    // 总共显示的天数
    let totalCount = 14
    // 出发日期之前需要显示的天数数量
    let beforeCount = 7
    // 出发日期 之后的天数集合
    let afterDates = []
    
    // 判断出发日期是否已过期 过期 出发日期重置为今天的日期
    if (dayjs(curDate).isBefore(now, 'day')) {
      curDate = now
    }
    // 出发日期 之前的天数集合
    let beforeDates = [curDate]
    // 获取出发日期 之前的天数集合
    let beforeStartDate = dayjs(curDate)
    while (beforeCount > 0) {
      // 获取之前一天
      beforeStartDate = beforeStartDate.subtract(1, 'day')
      // 判断之前一天是否已过期
      if (beforeStartDate.isBefore(now)) {
        beforeCount = 0
      } else {
        beforeCount -= 1
        beforeDates.unshift(beforeStartDate.format('YYYY-MM-DD'))
      }
    }
    // 获取出发日期 之后的天数集合
    // departDate之后需要显示的天数数量
    let afterCount = totalCount - beforeDates.length
    let afterDate = dayjs(curDate)
    while (afterCount > 0) {
      afterCount -= 1
      afterDate = afterDate.add(1, 'day')
      let flag = afterDate.diff(tomorrow, 'month')
      if (flag > 1) break;
      afterDates.push(afterDate.format('YYYY-MM-DD'))
    }
    return beforeDates.concat(afterDates)
  }, [currentDate])

  

  return useMemo(() => {
    return (
      <div>
        {!hideHead && <div className={style.dTitle}>
          <span className={style.tit}>选择日期</span>
          {!currentDate && <div className={style.tips}>请选择</div>}
        </div>}
        <div className={style.calendarHeader}>
          <div ref={containerDom} className={style.calendarScrollContainer}>
            <ul ref={ulDom}>
              {getDates.map((item, index) => {
                const obj = calendarDetailList?.find(m => m?.date == dayjs(item).format('YYYY-MM-DD'))
                return (
                  <CalendarItem
                    containerDom={containerDom}
                    disabled={!obj}
                    label={obj?.weekDay}
                    ulDom={ulDom}
                    icon={icon}
                    key={index}
                    date={item as any}
                    active={currentDate}
                    price={obj?.salePrice}
                    setActive={handleChange}
                  />
                )
              })}
            </ul>
          </div>
          <div className={style.lowPriceButton} onClick={handleOpen}>
            <div>
              <div>更多</div>
              <div>日期</div>
            </div>
            <Icon type="icon-list-right-outlined" />
          </div>
          <Calendar
            visible={state.visible}
            value={currentDate ? dayjs(currentDate).format('YYYY-MM-DD') : ''}
            onClose={handleClose}
            onChange={handleChange}
            calendarDetailList={calendarDetailList}
            icon={icon}
          />
        </div>
      </div>
    )
  }, [state, calendarDetailList])
}

export default CalendarHeader
